import { render, staticRenderFns } from "./EditProjectPage.vue?vue&type=template&id=866d500a&scoped=true&lang=html&"
import script from "./EditProjectPage.vue?vue&type=script&lang=js&"
export * from "./EditProjectPage.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectPage.vue?vue&type=style&index=0&id=866d500a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866d500a",
  null
  
)

export default component.exports